<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          :to="`/conferences/filters/add`"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <!--
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
        -->
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>
    </vx-card>
  </div>
</template>
<script>
import Service from "@/services";

export default {
  components: {},
  data: () => ({
    columns: [
      { label: "ID", key: "filter_id", sortable: false },
      {
        label: "Filter Name",
        key: "filter_name",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Filter Table",
        key: "filter_tbl",
        sortable: false,
        tdClass: "width-300",
      },
      {
        label: "Weight",
        key: "weight",
        sortable: false,
        tdClass: "width-300",
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
  }),
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.Filter.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            this.log = res.log;

            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push("/conferences/filters/" + item.filter_id + "/view");
    },
    /*
    list(item) {
      console.log(item);
      if(item.filter_tbl=='sponsor'){
          console.log()
      }
    },
    */
    /*
    duplicate(item) {
      this.$router.push("/conferences/speakers/add?clone=" + item.e);
    },
    */
  },
};
</script>